import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/whweb.scss' // 全局自定义css
import App from './App.vue'
import store from './store'
import router from './router'
import Utils from './utils/util'
import Config from './config'
import './permission' // permission control
import { getDicts } from "@/api/system/dict/data";
import { getUploadImgSize } from "@/api/system/config";
import { cutPrefix,joinPrefix } from "@/utils/editor";
import { selectDictLabel, resourceDownload, getImgUrl,
  getJsonElementArray,parseTime,randomString,
  replaceImgSrc, isExceedLimitSize, selectDeptName, resetForm ,
  handleDownload,handleDictTree ,isEmptyStr,dateCompare,logout} from "@/utils/yawei";
import Pagination from "@/components/Pagination";
import md5 from 'js-md5';
import { Notification, MessageBox, Message } from 'element-ui'
import {getLoginUser,getLogout} from "@/api/index";
import { getHmdOtherDetail } from "@/api/fwjg/fwjg";
import swal from 'sweetalert';
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
import {handleTree,handleTreeNoRootNode} from "./utils/yawei";
import {VueJsonp} from 'vue-jsonp';
Vue.config.productionTip = false

Vue.prototype.utils = Utils;
Vue.prototype.Config = Config;

Vue.prototype.resourceDownload = resourceDownload
Vue.prototype.getImgUrl = getImgUrl
Vue.prototype.replaceImgSrc = replaceImgSrc
Vue.prototype.getUploadImgSize = getUploadImgSize
Vue.prototype.cutPrefix = cutPrefix
Vue.prototype.joinPrefix = joinPrefix
Vue.prototype.isExceedLimitSize = isExceedLimitSize
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.handleDictTree = handleDictTree
Vue.prototype.selectDeptName = selectDeptName
Vue.prototype.resetForm = resetForm
Vue.prototype.getDicts = getDicts
Vue.prototype.handleTree = handleTree
Vue.prototype.handleTreeNoRootNode = handleTreeNoRootNode
Vue.prototype.getJsonElementArray = getJsonElementArray
Vue.prototype.parseTime = parseTime
Vue.prototype.randomString = randomString
Vue.prototype.md5 = md5
Vue.prototype.handleDownload = handleDownload
Vue.prototype.MessageBox = MessageBox
Vue.prototype.getLoginUser=getLoginUser
Vue.prototype.getHmdOtherDetail=getHmdOtherDetail
Vue.prototype.getLogout=getLogout
Vue.prototype.logout=logout
Vue.prototype.isEmptyStr=isEmptyStr
Vue.prototype.dateCompare=dateCompare


Vue.prototype.msgSuccess = function (msg) {
  // this.$message({ showClose: true, message: msg, type: "success" });
  swal("", msg, "success",{button: false,timer: 2000});
}

Vue.prototype.msgError = function (msg) {
  // this.$message({ showClose: true, message: msg, type: "error" });
  swal( "", msg,"error",{button: false,timer: 2000});
}

Vue.prototype.msgInfo = function (msg) {
  // this.$message.info(msg);
  swal( "", msg,"info",{button: false,timer: 2000});
}

Vue.prototype.msgWarning = function (msg) {
  // this.$message.info(msg);
  swal( "", msg,"warning",{button: false,timer: 2000});
}


// 全局组件挂载
Vue.component('Pagination', Pagination)

Vue.use(ElementUI, {
  size: 'medium' // set element-ui default size
})
Vue.use(VueJsonp);
Vue.component('ImageUpload', ImageUpload)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
